import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../../Global/Header";
import Footer from "../../Global/Footer";
import Sidebar from "./Sidebar";


const Layout = () => {
  return (
    <>
      <div className="min-h-screen flex flex-col bg-gray-100">
          <Header />
          <Sidebar/>
          <Outlet /> {/* This is where the child routes render */}
          <Footer />
      </div>
    </>
  );
};

export default Layout;